export default __webpack_public_path__ + "static/media/ic_person_order.e8aa9b36.png";